<template>
    <!-- <div v-if="!inWeiXinOrQQ" class="container" >
        <img class="img c1" src="https://app-test-1301744297.file.myqcloud.com/static/back_long.png" />
        <img class="img c2" src="https://app-test-1301744297.file.myqcloud.com/static/back_long.png" />

        <div  @touchmove.prevent class="p_title" draggable="false">
            <p class="contentText textTop">遇见有趣的人</p>
            <p class="contentText textBottom">聊情感的故事</p>

            <div class="divGap"></div>

            <img class="img_desc" src="../../assets/img_desc.png">
            <div class="button" @click="onPress" id="buttonMiYou">
                <img class="img_button" src="../../assets/img_button.png">
            </div>
        </div>
    </div> -->
    <div>
        <div class="container" >
            <div style="width: 100%; height: 220vw; position: relative;">
                <img style="width: 100vw;" src="../../assets/xinban/bg.png" />
                <div style="width: 100vw; height: 100px; position: absolute; bottom: 0px" @click="onPress"></div>
            </div>
            <img style="width: 100vw; position: fixed; bottom: 0; left: 0; z-index: 99;" src="../../assets/xinban/btn.png" @click="onPress" />
        </div>

        <div v-if="showJump" style="width: 100vw; height: 100vh; background-color:rgba(0, 0, 0, 0.6); position: fixed; top: 0; z-index: 100">
            <img style="right: 0px; float: right; width: 60vw; height: 24vw;" src="../../assets/tianmi/download_top.png">
        </div>
    </div>
</template>


<script>
import { is_weixin, isIos, is_qq } from '../../common/functions';

const url_android = 'https://app-test-1301744297.file.myqcloud.com/file/mimi/mimi_sh_1.8.2.apk';
const url_ios = 'http://www.baidu.com';

export default {
    data() {
        return {
            index: 1,
            inWeiXinOrQQ: false,
            showJump: false
        };
    },

    created() {
        document.title = "App下载";
        this.inWeiXinOrQQ = is_weixin() || is_qq();
        // this.inWeiXinOrQQ = true;
    },

    mounted() {
        
    },

    methods: {
        onPress() {
            // console.log('on press si - - - - >');
            if (is_weixin()) {
                // alert('请点击右上角使用外部浏览器打开后再进行下载!');
                this.showJump = true;
            } else {
                if (isIos()) {
                    // window.location.href = url_ios;
                    alert('敬请期待!');
                } else {
                    window.location.href = url_android;
                    // this.showJump = true;
                }
            }
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.img {
    position: absolute;
    width: 100%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 60s;
}

.c1 {
    animation-name: roll1;
}
.c2 {
    animation-name: roll2;
}
.img_desc {
    width: 200px;
    height: 20px;
    margin-bottom: 60px;
}
.img_button {
    width: 90%;
}

.p_title {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    display: flex;
    -webkit-user-drag: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
}

.contentText {
    font-size: 32px;
    color: #FFF;
    font-weight: 400;
    font-style: italic;
}
.textTop {
    margin-top: 20%;
    margin-left: -100px;
}
.textBottom {
    margin-top: -20px;
    margin-left: 100px;
}
.divGap {
    flex: 1;
}

.button {
    width: 70%;
    height: 60px;
    border-radius: 30px;
    margin-bottom: 20%;
    align-items: center;
    justify-content: center;
    display: flex;

    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 1.4s;
    animation-name: button;
}
.buttonTitle {
    font-size: 26px;
    color: #FFF;
    
}

.desc {
    font-size: 26px;
    background: linear-gradient(to right, gold, red);
    -webkit-background-clip: text;
    color: transparent;
    font-style: oblique;
}

@keyframes roll1 {
    0% { top: 0px }
    100% { top: -161% }
}
@keyframes roll2 {
    0% { top: 161% }
    100% { top: 0px }
}

@keyframes button {
    0% { width: 200px; height: 50px; }
    50% { width: 260px; height: 60px; }
    100% { width: 200px; height: 50px; }

    /* 0% { transform: translateX(-5%)}
    50% { transform: translateX(5%)}
    100% { transform: translateX(-5%)} */
}
</style>